import { capitalGlobalQuotesService } from '@/services/quotes/capital-global';
import type { DecideGlobalQuoteSubscriptionPayload } from '@/services/quotes/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useDecideGlobalQuoteSubscription(policyId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    retry: false,
    mutationFn: async (payload: DecideGlobalQuoteSubscriptionPayload) => {
      const response = await capitalGlobalQuotesService.decideSubscription(
        policyId,
        payload,
      );

      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao decidir subscrição');
      }

      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['proposal-details', policyId] });
      queryClient.invalidateQueries({ queryKey: ['quotes'] });
    },
  });
}
